import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { ReactComponent } from "../assets/project.svg";
import { ProjectPage__OnClick_Z11029FF1, ProjectPage__get_Href, ProjectPage } from "../ClientTypes.fs.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { map, singleton, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { defaultArg, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { useFeliz_React__React_useFetch_Static_6ADA66EC } from "../hooks/UseFetch.fs.js";
import { many } from "../Api/Projects.fs.js";
import { LoadingBar } from "../Assets.fs.js";
import { singleton as singleton_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import "./Projects.scss";


export function ProjectIcon(b) {
    const props = keyValueList(b, 1);
    return react.createElement(ReactComponent, props);
}

function Project(props) {
    let elems_1, elems;
    const page = new ProjectPage(0, [props.projectId]);
    return createElement("div", createObj(ofArray([["className", "project-wrap"], (elems_1 = [createElement("a", createObj(ofArray([["className", join(" ", ["project", "box"])], ["href", ProjectPage__get_Href(page)], ["onClick", (e) => {
        ProjectPage__OnClick_Z11029FF1(page, e);
    }], (elems = [ProjectIcon([["className", "project-icon"], ["title", props.name]]), createElement("h1", {
        children: props.name,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function Projects() {
    let elems_3, elms_1, elems_1, elms, xs_7;
    try {
        const projects = useFeliz_React__React_useFetch_Static_6ADA66EC(many, undefined, []);
        switch (projects.tag) {
            case 1:
                return LoadingBar([]);
            case 3: {
                const error = projects.fields[0];
                return createElement("article", createObj(Helpers_combineClasses("message", ofArray([["className", "is-danger"], (elems_1 = [createElement("div", createObj(Helpers_combineClasses("message-header", singleton(["children", "Something has gone wrong"])))), (elms = toList(delay(() => {
                    switch (error.tag) {
                        case 0: {
                            const pd = error.fields[1];
                            console.error(some(pd));
                            return singleton_1(createElement("p", {
                                children: [defaultArg(pd.Detail, pd.Title)],
                            }));
                        }
                        case 1: {
                            const matchValue = error.fields[0];
                            switch (matchValue.tag) {
                                case 2: {
                                    console.error(some(matchValue.fields[0]));
                                    return singleton_1(createElement("p", {
                                        children: ["Unable get projects"],
                                    }));
                                }
                                case 3: {
                                    const n = matchValue.fields[0];
                                    console.error(some(n));
                                    return singleton_1(createElement("p", {
                                        children: [`Network error: ${n.message}`],
                                    }));
                                }
                                case 0: {
                                    const n_1 = matchValue.fields[0];
                                    console.error(some(n_1));
                                    return singleton_1(createElement("p", {
                                        children: [`Could not start to get the projects: ${n_1.message}`],
                                    }));
                                }
                                default: {
                                    console.error(some(matchValue.fields[0]));
                                    return singleton_1(createElement("p", {
                                        children: ["Unable to understand projects"],
                                    }));
                                }
                            }
                        }
                        default: {
                            console.error(some(error.fields[0]));
                            return singleton_1(createElement("p", {
                                children: ["Something major has gone wrong"],
                            }));
                        }
                    }
                })), createElement("div", {
                    className: "message-body",
                    children: reactApi.Children.toArray(Array.from(elms)),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            }
            case 2:
                return createElement("section", {
                    className: "projects",
                    children: (xs_7 = map((project) => createElement(Project, {
                        key: project.ProjectId,
                        name: project.Name,
                        projectId: project.ProjectId,
                    }), projects.fields[0]), react.createElement(react.Fragment, {}, ...xs_7)),
                });
            default:
                return createElement("div", createObj(Helpers_combineClasses("notification", ofArray([["className", "is-info"], ["children", "Prepairing to get project config"]]))));
        }
    }
    catch (exn) {
        console.error(some(exn));
        return createElement("article", createObj(Helpers_combineClasses("message", ofArray([["className", "is-danger"], (elems_3 = [createElement("div", createObj(Helpers_combineClasses("message-header", singleton(["children", "Something has gone wrong"])))), (elms_1 = singleton(createElement("p", {
            children: ["Something major has gone wrong"],
        })), createElement("div", {
            className: "message-body",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
    }
}

